import { z } from 'zod'

import { DateZod } from '../../common'

import { PiloteOrganizationRecordZod } from './records'

export const PiloteOrganizationZod = z.object({
  timestamp: DateZod.nullable().optional(),
  organization: PiloteOrganizationRecordZod,
})
